export default __webpack_public_path__ + "static/desktop_KV01-d117562959b9b5af70790f0c3a7fa9a4.mp4";